import {
  IGetInProcessCheckRequest,
  IInProcessCheck,
  IPaginateApiResponse,
  IReviewInProcessRequest,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.inProcessCheck;

class InProcessCheckApiService extends BaseApiService {
  public getAllInProcessCheck = (request: IGetInProcessCheckRequest) =>
    this.get<IPaginateApiResponse<IInProcessCheck>>(`${prefix}`, {
      params: request,
    });
  public getInProcessCheckById = (id: string) =>
    this.get<IInProcessCheck>(`${prefix}/${id}`);
  public createInProcessCheck = (request: IInProcessCheck) =>
    this.post<IInProcessCheck, IInProcessCheck>(`${prefix}`, request);
  public updateInProcessCheck = (request: IInProcessCheck) =>
    this.put<IInProcessCheck, IInProcessCheck>(`${prefix}`, request);
  public reviewInProcessCheck = (
    id: string,
    request: IReviewInProcessRequest
  ) => this.put<IReviewInProcessRequest>(`${prefix}/${id}/review`, request);
  public deleteInProcessCheck = (id: string) =>
    this.delete<string>(`${prefix}/${id}`);
}

export default new InProcessCheckApiService();
